import Spinner from '../../../../components/Spinner';

const TyCalWeekLoading = () => {
  return (
    <div className="col-span-full flex">
      <Spinner show className="size-5 m-auto" />
    </div>
  );
};

export default TyCalWeekLoading;
